import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../../components/Header";
import { QRCodeCanvas } from "qrcode.react";
import confetti from "canvas-confetti";

function Confirmation() {
  const { id } = useParams();
  const [reservation, setReservation] = useState(null);

  useEffect(() => {
    const fetchReservation = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/reservation/${id}`,
          { withCredentials: true }
        );
        setReservation(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchReservation();
  }, [id]);

  // 🎉 CONFETTI
  useEffect(() => {
    if (!reservation) return;

    confetti({
      particleCount: 120,
      spread: 80,
      origin: { y: 0.6 },
    });
  }, [reservation]);

  if (!reservation) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p className="text-gray-500 animate-pulse">Chargement...</p>
      </div>
    );
  }

  return (
    <>
      <Header />

      <div className="pt-28 bg-gray-50 min-h-screen flex items-center justify-center px-4">

        <div className="w-full max-w-3xl bg-white rounded-2xl shadow-xl border overflow-hidden animate-fadeIn">

          {/* 🖼️ IMAGE */}
          {reservation.roomPhoto && (
            <div className="h-52 w-full overflow-hidden">
              <img
                src={reservation.roomPhoto}
                alt=""
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          )}

          <div className="p-8">

            {/* ✅ SUCCESS */}
            <div className="flex flex-col items-center text-center animate-slideUp">

              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-green-100 mb-4">
                <span className="text-green-600 text-3xl">✓</span>
              </div>

              <h1 className="text-2xl font-semibold text-gray-900">
                Réservation confirmée 🎉
              </h1>

              <p className="text-gray-500 mt-2 text-sm">
                Votre séjour est validé. Profitez pleinement ✨
              </p>

            </div>

            {/* 📊 INFOS */}
            <div className="mt-8 border-t pt-6 space-y-4 animate-fadeIn delay-150">

              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Référence</span>
                <span className="font-medium">{reservation.reservationId}</span>
              </div>

              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Hôtel</span>
                <span className="font-medium">{reservation.hotelName}</span>
              </div>

              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Chambre</span>
                <span className="font-medium">{reservation.roomTitle}</span>
              </div>

              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Dates</span>
                <span className="font-medium">
                  {new Date(reservation.checkInDate).toLocaleDateString()} →{" "}
                  {new Date(reservation.checkOutDate).toLocaleDateString()}
                </span>
              </div>

              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Total</span>
                <span className="font-semibold text-gray-900">
                  {reservation.totalPrice}€
                </span>
              </div>

            </div>

            {/* 🔳 QR CODE */}
            <div className="mt-8 flex flex-col items-center animate-fadeIn delay-300">

              <p className="text-sm text-gray-500 mb-3">
                Présentez ce QR code à votre arrivée
              </p>

              <div className="bg-white p-3 rounded-xl border shadow-sm">
                <QRCodeCanvas
                  value={reservation.reservationId}
                  size={120}
                />
              </div>

            </div>

            {/* 🔘 CTA */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 animate-fadeIn delay-500">

              <a
                href="/"
                className="flex-1 text-center px-5 py-2.5 rounded-lg text-sm font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
              >
                Retour à l'accueil
              </a>

              <a
                href="/my-reservations"
                className="flex-1 text-center px-5 py-2.5 rounded-lg text-sm font-medium bg-[#3A9D23] text-white hover:bg-[#33891E] transition"
              >
                Voir mes réservations
              </a>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}

export default Confirmation;